import {StyledAGPContainer} from './Styles'
import ChatViewIndex from './AskGPViews/ChatView/ChatViewIndex'
import ManualFiltersView from './AskGPViews/ManualFiltersViewIndex'
import {useSelector} from 'react-redux'

const AskGivePrism = () => {
  const switchFilters = useSelector((state) => state.askGivePrism.switchFilters)
  return (
    <StyledAGPContainer switchFilters={switchFilters} containerHeight={switchFilters ? '590px' : '500px'}>
      {!switchFilters && <ChatViewIndex />}
      {switchFilters && <ManualFiltersView />}
    </StyledAGPContainer>
  )
}

export default AskGivePrism
